import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

import {
  IonContent, IonHeader, IonPage, IonButtons, IonMenuButton,
  IonTitle,
  IonToolbar, IonList, IonItem, IonLabel, onIonViewDidEnter,
} from '@ionic/vue';
import { ref } from 'vue';
import dayjs from 'dayjs'
import { useAuthStore } from '@/stores/auth.store';
import EmptyState from './components/EmptyState.vue'
import ListSkeletton from './components/ListSkeletton.vue'
import { rangeDateText } from '@/helpers/date';
import { getApi } from '@/helpers/api';
import { PeriodContractsApi, DtoContract } from 'ppf-api-client';



export default /*#__PURE__*/_defineComponent({
  __name: 'ContractsPage',
  setup(__props) {

const contracts = ref<DtoContract[]>([]);
const loading = ref(true);

const service = getApi(PeriodContractsApi);
const auth = useAuthStore();

//load inital data when entering the tab
onIonViewDidEnter(() => {
  loading.value = true;
  contracts.value = [];

  service.periodContractsByPersonnel(auth.userId).then(r => {
    contracts.value = r.sort((a, b) => {
      const at = a.start ? a.start.getTime() : 0;
      const bt = b.start ? b.start.getTime() : 0;
      return bt - at
    });
    loading.value = false;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton))
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('p.contract.title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonList), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contracts.value, (c) => {
                return (_openBlock(), _createBlock(_unref(IonItem), {
                  key: c.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      slot: "start",
                      class: "fa fa-circle fa-sm fa-fw",
                      style: _normalizeStyle({ color: c.color || '#000' })
                    }, null, 4),
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(c.type), 1),
                        _createElementVNode("p", null, _toDisplayString(_unref(rangeDateText)(c.start, c.end)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(IonLabel), { slot: "end" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_unref(dayjs).duration(c.duration || '0').asHours()) + "h", 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(ListSkeletton, {
            style: _normalizeStyle({ display: loading.value ? 'block' : 'none' })
          }, null, 8, ["style"]),
          _createVNode(EmptyState, {
            style: _normalizeStyle({ display: loading.value || contracts.value.length > 0 ? 'none' : 'block' }),
            icon: "fa-file-signature"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('p.contract.empty')), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})